<template>
  <transition name="fade" appear>
    <div class="cj-modal" v-if="show">
      <slot />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CJModal',

  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="stylus" scoped>
  .cj-modal
    position: absolute
    top: 0
    left: 0
    right: 0
    height: 100%
    background-color: rgba(0, 0, 0, 0.6)
</style>
